import {
    faCheckCircle,
    faWarning,
} from '@awesome.me/kit-eee5f32034/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NoticeType } from '@onwardtravelsolutions/package-react/Enums';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import { toTitleCase } from '@onwardtravelsolutions/package-react/Utilities/strings';

type ValidationListProps = {
    fieldName: string;
    notices: Notice[];
    className?: string;
};

export default function ValidationList({
    fieldName,
    notices,
    className = '',
}: ValidationListProps) {
    const getIcon = (type: NoticeType) =>
        ({
            [NoticeType.Error]: faWarning,
            [NoticeType.Warning]: faWarning,
            [NoticeType.Information]: faCheckCircle,
        })[type] ?? faWarning;

    const getColor = (type: NoticeType) =>
        ({
            [NoticeType.Error]: 'text-error',
            [NoticeType.Warning]: 'text-orange-200',
            [NoticeType.Information]: 'text-blue-200 dark:bg-blue-400',
        })[type] ?? 'text-orange-200';

    return (
        <ul
            className={`bg-white dark:bg-neutral-800 rounded-b border-gray-200 dark:border-gray-600 border p-0 text-xs ${className}`}
        >
            {notices.map(({ type, meta, title, body }, i) => {
                const search = fieldName
                    ? new RegExp(String.raw`\b(${fieldName})\b`, 'g')
                    : null;
                return (
                    <li
                        className={`flex flex-row items-center ${getColor(type)}`}
                        key={`validation-${fieldName}-${i}`}
                    >
                        <div className='flex justify-center p-y border-box w-10 h-full shrink-0'>
                            <FontAwesomeIcon icon={getIcon(type)} />
                        </div>
                        <div className='flex flex-col py-2 pr-2'>
                            {(meta?.showTitle ?? false) ? (
                                <h4 className='font-bold text-xs'>
                                    {toTitleCase(title)}
                                </h4>
                            ) : null}
                            <p className='text-gray-400 text-xs'>
                                {search
                                    ? body.replace(
                                          search,
                                          (reference) =>
                                              "'" +
                                              toTitleCase(
                                                  reference.replace('-', ' '),
                                              ) +
                                              "'",
                                      )
                                    : body}
                            </p>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
